<i18n>
{
  "no": {
    "SEND_OTP_TO_ANOTHER_NUMBER": "Ønsker du å få koden til ett annet nummer? "
  },
  "en": {
    "SEND_OTP_TO_ANOTHER_NUMBER": "Receive one time code to different number? "
  }
}
</i18n>

<template>
  <div v-if="phoneNumbers.length > 0" class="otp-alternatives">
    <TnLink
      size="s"
      :icon-right="numberListOpen ? 'chevron-up' : 'chevron-down'"
      :text="t('SEND_OTP_TO_ANOTHER_NUMBER')"
      @click="numberListOpen = !numberListOpen"
    />

    <ul v-if="numberListOpen" class="margin-top-s">
      <li v-for="number in phoneNumbers" :key="number.phoneNumberId" class="otp-alternative">
        <TnHeading type="h3" size="3xs">{{ number.phoneNumberMasked }}</TnHeading>
        <TnButton
          size="s"
          secondary
          compact
          text="Send"
          @click="emit('otpNumberClicked', number)"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { TnButton, TnHeading, TnLink } from '@telenornorgeinternal/telegrafen-vue3-core';

import type { OtpPhoneNumber } from '@/views/elvis/api';

withDefaults(defineProps<{ phoneNumbers?: OtpPhoneNumber[] }>(), {
  phoneNumbers: () => [],
});

const emit = defineEmits<{ otpNumberClicked: [number: OtpPhoneNumber] }>();

const { t } = useI18n();

const numberListOpen = ref(false);
</script>

<style scoped>
.otp-alternatives {
  padding-inline: 8px;
  padding-block: 24px;
}

.otp-alternative {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
}
</style>
